module.exports = __webpack_public_path__ + "img/sj-mobile@2x.c817c709.png";